import { ReactComponent as PenIcon } from "../../../../assets/svg/icons/penEdit.svg";
import "../../TaskEvaluation/styles.css";
import "./styles.css";
import { useEditOnboarding } from "../../../../hooks/useEditOnboarding";
import { useTranslation } from "react-i18next";

type TableVisualizationRowProps = {
  product: IProducts;
};

export default function TableVisualizationRow({
  product,
}: TableVisualizationRowProps) {
  const { t } = useTranslation();
  const {
    setOptionForm,
    setDefaultValue
  } = useEditOnboarding();

  return (
    <tr>
      <td>{product.classification}</td>
      <td>{product.trade_name}</td>
      <td>{product.manufacturer}</td>
      <td>
        {product.packaging_type === "BAGGED"
          ? `${t("formsV2.packagingBagged")} (${product.bag_weight_kg} kg)`
          : t("formsV2.packagingBulk")}
      </td>
      <td>{t(product.creep_feeding ? "tables.products.creepFeedingYes" : "tables.products.creepFeedingNo")}</td>
      <td className="infoButton">
        <button type="button" className="table-action-button"
          aria-label={t("tables.products.edit", { name: product.trade_name })}
          onClick={() => {
            setOptionForm("create-products")
            setDefaultValue(product)
          }}>
          <PenIcon aria-hidden="true" />
        </button>
      </td>
    </tr>
  );
}
